import { INVALID_PARAMETER } from '../constants/api-error-enums';
import DpaTransactionOptions from '../schemas/dictionary/dpa-txn-options';
import constructValidationMessage from './construct-validation-message';

const validateDpaTransactionOptions = data => {
  const { error } = DpaTransactionOptions.validate(data, {
    abortEarly: false,
    allowUnknown: true
  });

  let reason;
  if (error) {
    reason = INVALID_PARAMETER;
  }

  return constructValidationMessage(error, 'dapTransactionOptions', reason);
};

export default validateDpaTransactionOptions;
